import { useTranslations } from "next-intl";
import type { LevelAccessHint } from "@/lib/user-level/access";

export function AiResourcePrice({ free, price, owned = false, membership, mode = "points", kind }: {
  free: boolean; price: number; owned?: boolean; membership?: LevelAccessHint; mode?: "points" | "once" | "per_call"; kind?: string;
}) {
  const t = useTranslations("site.ai");
  if (membership?.exclusive && membership.usable === false) return t("accessRequired");
  if (membership?.granted && mode !== "per_call") return t(kind === "agent" ? "freeUse" : "free");
  if (free) return membership?.allowed === false ? membership.requiredLevelName || t("accessRequired") : t(kind === "agent" ? "freeUse" : "free");
  if (owned) return t("owned");
  return t(mode === "once" ? "once" : mode === "per_call" ? "perCall" : "points", { points: price });
}
